import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, XIcon } from "lucide-react";
import { TransformButton } from "./TransformButton";
const BEFORE = ["Dudabas antes de aceptar un caso complejo", "Definías la DVO por intuición", "Improvisabas según el paciente", "Temías los retrabajos", "Derivabas tratamientos complejos", "Cada caso era diferente"];
const AFTER = ["Evalúas cada caso con un protocolo claro", "Tomas decisiones con criterios objetivos", "Sigues un proceso paso a paso", "Planificas con mayor previsibilidad", "Aumentas la confianza para aceptarlos", "Todos siguen el mismo método clínico"];
export function BeforeAfter() {
  return <section className="w-full bg-[var(--cream)] px-4 py-14" data-id="element-26" data-mp="39qbxvpta9tqw">
      <div className="mx-auto max-w-3xl text-center" data-id="element-27" data-mp="39osjy5v3nusa">
        <h2 className="font-serif-display text-2xl font-extrabold leading-tight text-gray-900 sm:text-4xl" data-id="element-28" data-mp="2vs586wyhn02b">
          De un odontólogo que duda antes de cada rehabilitación…{" "}
          <span className="italic text-[var(--brand)]" data-id="element-29" data-mp="x40us94bck4x">
            a un profesional que diagnostica con un sistema.
          </span>
        </h2>
        <p className="mt-3 text-sm text-gray-600 sm:text-base" data-id="element-30" data-mp="t2p2twxyvmtk">
          Más de <strong data-id="element-31" data-mp="171otfa51ibsd">2.400 horas de incertidumbre clínica reducidas.</strong>
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-32" data-mp="123dhmtv6pr7i">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl border border-red-100 bg-red-50/60 p-5 text-left" data-id="element-33" data-mp="121u0z25m9e57">
            <h3 className="mb-4 flex items-center gap-2 text-base font-bold text-red-700" data-id="element-34" data-mp="o4xc369266qy">
              <span className="text-xl" data-id="element-35" data-mp="jcvqgtq033o9">❌</span> Antes
            </h3>
            <ul className="space-y-3" data-id="element-36" data-mp="3rsyyj0l0yud4">
              {BEFORE.map(item => <li key={item} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-37" data-mp="3rqvzjr1w9qw9">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" data-id="element-38" data-mp="3mtm49urtql0i" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl border border-green-200 bg-green-50/70 p-5 text-left shadow-sm" data-id="element-39" data-mp="1voj59qo15gem">
            <h3 className="mb-4 flex items-center gap-2 text-base font-bold text-[var(--cta-dark)]" data-id="element-40" data-mp="17s54uwpjh0wh">
              <span className="text-xl" data-id="element-41" data-mp="1cqgb6xgmkt9y">✅</span> Con Protocolo Clínica Segura
            </h3>
            <ul className="space-y-3" data-id="element-42" data-mp="1gstelf7wgf3k">
              {AFTER.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-gray-800" data-id="element-43" data-mp="1guweqs2rnom0">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[var(--cta)]" strokeWidth={3} data-id="element-44" data-mp="1lpa70lm4tfmg" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <TransformButton label="Quiero diagnosticar con un sistema" data-id="element-45" data-mp="37agvf4ric0n1" />
      </div>
    </section>;
}